import React, { useState } from 'react'

const ImageCarousel = ({ images, alt, className }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  // If no images, return empty div with the given class
  if (!images || images.length === 0) {
    return <div className={className} />
  }

  // Single image - no need for navigation
  if (images.length === 1) {
    return (
      <div className={`${className} relative overflow-hidden bg-gray-100`}>
        <img
          src={images[0]}
          alt={alt}
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
        />
      </div>
    )
  }

  const handleNext = (e) => {
    e.stopPropagation() // Prevent parent card click
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
  }

  const handlePrev = (e) => {
    e.stopPropagation() // Prevent parent card click
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    )
  }

  return (
    <div className={`${className} relative group overflow-hidden bg-gray-100`}>
      <img
        src={images[currentIndex]}
        alt={`${alt} - image ${currentIndex + 1} of ${images.length}`}
        className="w-full h-full object-cover"
        loading="lazy"
        decoding="async"
      />

      {/* Navigation buttons - only shown on hover */}
      <button
        className="absolute left-0 top-1/4 w-12 h-1/2 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        onClick={handlePrev}
        aria-label="Previous image"
      >
        <span className="bg-black bg-opacity-50 text-white rounded-full w-6 h-6 flex items-center justify-center">
          ←
        </span>
      </button>

      <button
        className="absolute right-0 top-1/4 w-12 h-1/2 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        onClick={handleNext}
        aria-label="Next image"
      >
        <span className="bg-black bg-opacity-50 text-white rounded-full w-6 h-6 flex items-center justify-center">
          →
        </span>
      </button>

      {/* Dots indicator */}
      <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex space-x-1">
        {images.map((_, index) => (
          <span
            key={index}
            className={`w-1.5 h-1.5 rounded-full ${
              index === currentIndex ? 'bg-white' : 'bg-white bg-opacity-50'
            }`}
          />
        ))}
      </div>
    </div>
  )
}

export default ImageCarousel
